import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Rating from '@mui/material/Rating';

const UserRatingDisplay = ({ ratingsArr }) => {
  const [userRatings, setUserRatings] = useState([]);
  const [skillAvg, setSkillAvg] = useState(0);
  const [viewSkillAvg, setViewSkillAvg] = useState(0);
  const [teamAvg, setTeamAvg] = useState(0);
  const [viewTeamAvg, setViewTeamAvg] = useState(0);
  useEffect(() => {
    const calculateAvg = () => {
      // Sum the skillset ratings
      const skillsetRatingSum = ratingsArr.reduce((sum, ratingObj) => {
        return sum + parseFloat(ratingObj.skillset_rating);
      }, 0);

      // Sum the team ratings
      const teamRatingSum = ratingsArr.reduce((sum, ratingObj) => {
        return sum + parseFloat(ratingObj.team_member_rating);
      }, 0);

      // Determine the averages
      const skillsetRatingAvg = skillsetRatingSum / ratingsArr.length;
      const teamRatingAvg = teamRatingSum / ratingsArr.length;

      // Set the string values in state to render
      setSkillAvg(skillsetRatingAvg);
      setViewSkillAvg(skillsetRatingAvg.toFixed(1))
      setTeamAvg(teamRatingAvg);
      setViewTeamAvg(teamRatingAvg.toFixed(1))
    };

    if (ratingsArr?.length) {
      calculateAvg();
    } else {
      setSkillAvg(null);
      setTeamAvg(null);
    }
  }, [ratingsArr]);

  useEffect(() => {
    if (ratingsArr?.length > 0) {
      setUserRatings(ratingsArr);
    }
  }, [ratingsArr]);

  return (
    <div className="container--user_ratings">
      <div className="container--user_rating_one container--user_rating_card">
        <h5 className="header header--user_rating">Skillset Rating</h5>
        {skillAvg !== null ? (
          <div className="rates">
            <Rating value={skillAvg} precision={0.5} readOnly max={5} />
            <p className="text text--user_rating">
              {viewSkillAvg}
              <span>/5</span>
            </p>
          </div>
        ) : (
          "Not enough ratings yet"
        )}
      </div>
      <div className="container--user_rating_two container--user_rating_card">
        <h5 className="header header--user_rating">Teamplayer Rating</h5>
        {teamAvg !== null ? (
          <div className="rates">
            <Rating value={teamAvg} precision={0.5} readOnly max={5} />
            <p className="text text--user_rating">
              {viewTeamAvg}
              <span>/5</span>
            </p>
          </div>
        ) : (
          "Not enough ratings yet"
        )}
      </div>
    </div>
  );
};

export default UserRatingDisplay;

UserRatingDisplay.propTypes = {
  ratingsArr: PropTypes.array,
};
